import { IAppState } from '../../common/state';
import {
  getNewbuildingRentTrapExperimentGroup,
  TNewbuildingRentTrapExperimentGroup,
} from '../../utils/experiments/getNewbuildingRentTrapExperimentGroup';

export function selectNewbuildingRentTrap({ abUseExperiments }: IAppState): TNewbuildingRentTrapExperimentGroup {
  return getNewbuildingRentTrapExperimentGroup(abUseExperiments);
}
